import { getValidAccessToken } from "../../../Services/oauthService";
import { apiFetch } from "../../../utils/apiClient";

export const updateQuotesMedical = (data) => {
    
  return async (dispatch) => {
  const token = await getValidAccessToken();
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/medical/quotes`, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      });
      return val;
    } catch (error) {
      console.error('Error in updateQuotesMedical:', error);
      throw error;
    }
  };
};

export const uploadPolicyDocumentMedical = (data,quoteId) => {
    
  return async (dispatch) => {
  const token = await getValidAccessToken();
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/medical/quotes/uploadPolicyPdfDocument/${quoteId}`, {
        method: 'PUT',
        body: data, 
      });
      return val;
    } catch (error) {
      console.error('Error in uploadPolicyDocumentLife:', error);
      throw error;
    }
  };
};